<template>
    <review-report-view
      :caseId="caseId"
      :routeFindingsName="'ReviewReportFindingsView'"
      :routeCommentsName="'ReviewReportCommentsView'">
    </review-report-view>
</template>

<script>
  import ReviewReportView from '@/views/generic/caseReview/ReviewReportView'

  export default {
    name: 'case-review-report-view',
    components: {
      ReviewReportView
    },
    props: {
      caseId: {
        required: true
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
